<style scoped lang="less">
.layout{width: 390px;height: auto;background: rgba(34, 85, 172, 0.88);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;transform: translate(-50%, -50%);border: 1px solid #6491e0;border-radius: 6px;}
.title{height: 35px;background-color: #2080ff;margin: 0;line-height: 35px;text-align: right;padding: 0 20px;color: #fff; font-size: 16px;display: flex;justify-content: space-between;}
.popup-tool {height: 45px;line-height: 45px;color: #fff; font-family: Microsoft YaH;text-align: left;padding: 0px 10px;border:solid 1px rgb(33, 185, 191)}
.popup-content {color: #d6d4d4; font-family: Microsoft YaH;text-align: left;padding: 5px;border-top: none;}
.ol-popup-closer:after {content: "✖";color: #fff;}
/deep/.el-input.is-disabled .el-input__inner {background: rgba(10, 17, 43, 0.4);border: solid 1px #3c818d;}
/deep/.el-select .el-input.is-disabled .el-input__inner:hover {border: solid 1px #3c818d;}
/deep/.el-form-item__label {padding: 0;color: #fff;text-align: center;}
/deep/.el-form-item {margin: 15px;}
/deep/.el-input__inner {color: #000;}
.markbox {height: 40px;width: 250px;display: flex;flex-direction: row; justify-content:space-around;padding: 0;margin: 0;list-style: none;}
.el-radio-button {width: 40px;height: 40px;}
/deep/.el-radio-button__inner {width: 40px;height: 40px;}
/deep/.el-radio-button__inner img{width: 40px;height: 40px;position: absolute;top: 0px;left: 0px;}
.el-button {border-radius: 4px;border: solid 1px #2080ff;}
.el-button--primary {color: #FFF;background-color: #2080ff;}
.el-button--default {color: #FFF;background: #2080ff;}
/deep/.el-input__inner{ background-color: transparent !important; border: solid 1px #7ae9ff;border-radius: 5px;color: #fff;}
/deep/.el-tabs__nav{padding: 0px !important;width: 100%;text-align: center;overflow: auto;}
/deep/.el-tabs__item.is-left {width: 100px;font-size: 14px;color: #FFF;padding: 0;text-align: center;}
/deep/.el-tabs__item.is-active {color: #7ae9ff;}
/deep/.el-tabs__active-bar {color: #7ae9ff;}
/deep/.el-tab-pane {height: 345px;overflow: auto;}
/deep/.el-tab-pane .el-form {height: 100%;display: flex;flex-direction: column;justify-content: space-around;}
/deep/.popup-content-type {height: 340px;}
/deep/.popup-content-type .el-form {height: 100%;display: flex;flex-direction: column;justify-content: space-around;}
/deep/.markbox {height: 40px;width: 250px;display: flex;flex-direction: row; justify-content:space-around;padding: 0;margin: 0;list-style: none;}
.el-radio-button {width: 40px;height: 40px;}
/deep/.el-radio-button__inner {width: 40px;height: 40px;background: rgba(10, 17, 43, 0.4);border:none!important;box-shadow:0 0 0 0}
/deep/.el-radio-button__inner img{width: 40px;height: 40px;position: absolute;top: 0px;left: 0px;}

</style>

<template>
<div class="layout" v-drag v-if="flag">
    <p class="title">
      <span>图例</span>
      <a href="#" id="popup-closer" class="ol-popup-closer" @click="closePul(false)"></a>
    </p>
    <div class="popup-content">
      <el-tabs v-model="activeName" @tab-click="handleClick" tab-position="left">
          <el-tab-pane  v-for="(item,index) in this.legendData"  :key="item" :label="item.title" :name="index+1">
            <img :src="item.legendImg" alt="" style="width: 100%;">
          </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>

export default {
  data()
  {
    return {
      flag: false,
      activeName: 1,
      legendData: []
    }
  },
  created()
  {
  },
  methods: {
    getLegendData(data)
    {
      if (data.length > 0)
      {
        this.activeName = 1
        this.legendData = []
        this.legendData.push(...data)
      }
      else
      {
        this.flag = false
        this.legendData.splice(0, this.legendData.length)
      }
    },
    showLP()
    {
      if (this.legendData.length > 0)
        this.flag = !this.flag
      else
        this.$message({message: '请先勾选图层', type: 'error'})
    },
    closePul(show)
    {
      this.flag = show
    },
    // 点击切换tab
    handleClick(val)
    {
      if (val.name === 'first')
        this.form2 = {}
      else
        this.form = {}
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/kyxxyzt/Legend.vue